import { render, staticRenderFns } from "./my-task-list.vue?vue&type=template&id=5d1fe456&scoped=true"
import script from "./my-task-list.vue?vue&type=script&lang=js"
export * from "./my-task-list.vue?vue&type=script&lang=js"
import style0 from "./my-task-list.vue?vue&type=style&index=0&id=5d1fe456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1fe456",
  null
  
)

export default component.exports